import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import  CertPaymentModel  from "../../models/certpayment";
import BFileInput from "../../helpers/bfile-input";

class CertFileUploadModal  extends Component {
    constructor() {
        super();
    
        this.state = {
          modalIsOpen: false,
          model:{
            CertReqId:null,
            Files:[]
          }
          
        };
    
        this.openModal = this.openModal.bind(this);
       
        this.closeModal = this.closeModal.bind(this);
        this.submit=this.submit.bind(this);
        //this.refreshModel= this.refreshModel.bind(this);
        this.updateImages=this.updateImages.bind(this);
      }
    
      openModal(id) {
        const {model}=this.state;
        model.CertReqId=id;
        model.Files=[];
        this.setState({modalIsOpen: true,model:model});
      }
      updateImages(images) {
        console.log(images);
      }
    
     
      closeModal() {
        this.setState({modalIsOpen: false});
        
      }

      submit(){
        const {model}=this.state;  
        this.props.submitFileHandler(model);
        this.closeModal();
      }
      updateImages(images) {
        const {model}=this.state;  
        var files = images.map(function(image) {
          return image.name
        });
        
        console.log('files',files);
        model.Files=files;
        this.setState({model:model});

        console.log('model',model);
        
      }

      
      getData() {
          let model = new CertPaymentModel(this.refs);
          return model;
      }
     
    
      render() {
        const {model} = this.state;
        return (
           <Modal style={{opacity:1}} show={this.state.modalIsOpen} onHide={this.closeModal} centered size="lg" aria-labelledby="contained-modal-title-vcenter" >
 
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                   ارسال فایل
                </Modal.Title>
            </Modal.Header>    
            <Modal.Body>
                <BFileInput  updateImagesHandler={this.updateImages}></BFileInput>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeModal}>
                انصراف
              </Button>
              <Button variant="primary" onClick={this.submit}>
                تایید
              </Button>
            </Modal.Footer>
          </Modal>
        );
      }
}

 
export default CertFileUploadModal;